function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464 464",
    style: {
      enableBackground: "new 0 0 464 464"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AAAE7"
    },
    d: "M432,400H32c-17.673,0-32-14.327-32-32V96c0-17.673,14.327-32,32-32h400c17.673,0,32,14.327,32,32 v272C464,385.673,449.673,400,432,400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M96,368H48c-8.837,0-16-7.163-16-16v-32c0-8.837,7.163-16,16-16h48c8.837,0,16,7.163,16,16v32 C112,360.837,104.837,368,96,368z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 128,
    style: {
      fill: "#4D4D4D"
    },
    width: 464,
    height: 48
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F40E34"
    },
    points: "432,232 392,208 392,256 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 208,
    style: {
      fill: "#FFD422"
    },
    width: 280,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 296,
    style: {
      fill: "#1E81CE"
    },
    width: 304,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 328,
    style: {
      fill: "#1E81CE"
    },
    width: 304,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 360,
    style: {
      fill: "#1E81CE"
    },
    width: 304,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 88,
    style: {
      fill: "#1E81CE"
    },
    width: 128,
    height: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 88,
    style: {
      fill: "#FFFFFF"
    },
    width: 72,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 88,
    style: {
      fill: "#FFFFFF"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 88,
    style: {
      fill: "#FFFFFF"
    },
    width: 16,
    height: 16
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.eaf2b61c.svg";
export { ForwardRef as ReactComponent };